import React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'features/auth/authSlice';
import { ErrorState } from 'components/ErrorState/ErrorState';
import UnexpectedErrorOne from 'assets/images/ErrorState/UnexpectedErrorOne.svg';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { useWeightDetails } from 'features/progress/hooks/useWeightDetails';
import { WeightWidgetCard } from 'components/WeightWidgetCard/WeightWidgetCard';

interface WeightProgressWidgetProps {
  onClick: () => void;
  className?: string;
  requestedTracker?: { programName: string; requestedOn: string };
}

/**
 * Progress-tab entry point to the Weight detail screen. Renders the current
 * week's weight summary; ignores paging (`dateRange`) since the widget is
 * a static snapshot.
 */
export const WeightProgressWidget: React.FC<WeightProgressWidgetProps> = ({
  onClick,
  className,
  requestedTracker,
}) => {
  const user = useSelector(selectUser);
  const { translation } = useTranslationContext();
  const { dates, weights, latestValue, unit, isLoading, isError } = useWeightDetails(user?.id);

  return (
    <WeightWidgetCard
      className={className}
      onClick={onClick}
      dates={dates}
      weights={weights}
      value={latestValue}
      unit={unit}
      isLoading={isLoading}
      errorContent={
        isError ? (
          <ErrorState
            imageArray={[UnexpectedErrorOne]}
            title={translation('request_failed')}
            subtitle={translation('generic_failure_error')}
          />
        ) : undefined
      }
      requestedTracker={requestedTracker}
    />
  );
};
